import { OrderDetailPage, Remark } from "@careinfo/layout";
import {
  AccessControl,
  ClientAccessControl,
} from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useSessionStorage } from "@uidotdev/usehooks";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import { classNames } from "../../utils/classNames";
import { hasValues } from "../../utils/hasValues";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import Modal from "../Reusable/Modal";
import TableActionButton from "../Reusable/TableActionButton";
import OrderMenu from "./ConsignmentMenu";
import DownloadActionMenu from "./DownloadActionMenu";
import OrderActionMenu from "./OrderActionMenu";
import ScanQrCode from "./ScanQrCode";
import Suborders from "./Suborders";
import TrashIcon from "../../Icons/TrashIcon";
import { queryClient } from "../../router/VehicleManifestRouter";
import OperationCombobox from "../Reusable/OpeationCombobox";
import DeliveryPartnerMenu from "../DeliveryPartnerMenu";
import EditDeliveryCharge from "./EditDeliveryCharge";
import DeliveryForm from "../Reusable/DeliveryForm";

interface IDeliveryStatusIn {
  id: string;
  label: string;
  name: string;
  value: string;
}

export interface IFilter {
  is_rtv: string | null;
  order_remarks__isnull: string | null;
  is_walking_customer: string | null;
  delivery_status__in: IDeliveryStatusIn[] | null;
  pickup_branch: string | null;
  destination: string | null;
  payment_method: string | null;
  pickup_branch__warehouse: string | null;
  destination_branch__warehouse: string | null;
  vendor: string | null;
  created__range: string | null;
  sender: string | null;
  receiver: string | null;
  assign_order: string | null;
  staff: string | null;
  operations: string | null;
  comment: string | null;
  destination__in: string | null;
}

const ConsignmentList = ({
  handleDelete,
  isLoading,
  openDeletePopup,
  setOpenDeletePopup,
  commentMethods,
  resetComment,
  status,
  cityIds,
}: any) => {
  console.log(cityIds, "ramesh");

  const [searchParams, setSearchParms] = useSearchParams();
  const [localState, handleSetState] = useSessionStorage<IFilter>(
    "consignment-filter",
    {
      is_rtv: null,
      order_remarks__isnull: null,
      is_walking_customer: null,
      delivery_status__in: null,
      pickup_branch: null,
      destination: null,
      payment_method: null,
      pickup_branch__warehouse: null,
      destination_branch__warehouse: null,
      vendor: null,
      created__range: null,
      sender: null,
      receiver: null,
      assign_order: null,
      staff: null,
      operations: null,
      comment: null,
      destination__in: null,
    }
  );
  const {
    register,
    setValue,
    getValues,
    watch,
    setError,
    reset,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IFilter>({
    defaultValues: async () => ({
      is_rtv: localState?.is_rtv ?? null,
      order_remarks__isnull: localState?.order_remarks__isnull ?? null,
      is_walking_customer: localState?.is_walking_customer ?? null,
      delivery_status__in: null,
      // delivery_status__in: [
      //   {
      //     id: "918b8bf2-cc0a-4c43-be9c-c864f3416808",
      //     label: "Pending Dispatch",
      //     name: "Pending Dispatch",
      //     value: "918b8bf2-cc0a-4c43-be9c-c864f3416808",
      //   },
      // ],
      pickup_branch: localState?.pickup_branch ?? null,
      destination: localState?.destination ?? null,
      payment_method: localState?.payment_method ?? null,
      pickup_branch__warehouse: localState?.pickup_branch__warehouse ?? null,
      destination_branch__warehouse:
        localState?.destination_branch__warehouse ?? null,
      vendor: localState?.vendor ?? null,
      created__range: localState?.created__range ?? null,
      sender: localState?.sender ?? null,
      receiver: localState?.receiver ?? null,
      assign_order: localState?.assign_order ?? null,
      staff: localState?.staff ?? null,
      operations: localState?.operations ?? null,
      comment: null,
      destination__in: cityIds?.length
      ? cityIds
      : localState?.destination__in ?? null,
    }),
  });
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));
  const [chargevalue, setChargeValue] = useState();
  const [orderActionMenu, setOrderActionMenu] = useState(false);
  const [actionType, setActionType] = useState("");
  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [openorderhistoryPopup, setOpenOrderHistoryPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [openDeliveryModal, setOpenDeliveryModal] = useState(false);
  const [openSuborderpopup, setOpensuborderPopup] = useState(false);
  const [rowid, setRowid] = useState();
  const [isactive, setISactive] = useState("trackbutton");
  const [deleteOrder, setDeleteOrder] = useState();
  const [openDeliveryformPopup, setOpenDeliveryformPopup] = useState(false);
  const [deliveryStatus, setDeliveryStatus] = useState(false);

  const operationData = [
    { id: "Pickup (Receive)", name: "Pickup (Receive)" },
    { id: "Manifest (Receive)", name: "Manifest (Receive)" },
    { id: "Delivery", name: "Delivery" },
  ];

  const handleFilterReset = () => {
    reset({
      is_rtv: null,
      order_remarks__isnull: null,
      is_walking_customer: null,
      delivery_status__in: null,
      pickup_branch: null,
      destination: null,
      payment_method: null,
      pickup_branch__warehouse: null,
      destination_branch__warehouse: null,
      vendor: null,
      created__range: null,
      sender: null,
      receiver: null,
      assign_order: null,
      staff: null,
      operations: null,
    });
  };

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
    navigateURL: "",
  });
  const { data: deliveryPartnerData } = useGetHook({
    url: APIS.DELIVERY_PARTNER,
    queryKey: ["delivery-partner"],
    params: {
      is_active: true,
    },
  });

  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const selectedOrderDetails = searchParams.get("selectedItem");
  const location = useLocation();
  const navigate = useNavigate();

  const appendSelectedItem = useCallback(
    (selectedItem: any) => {
      const params = new URLSearchParams(location.search);
      params.set("selectedItem", selectedItem);

      const newFullPath = `${location.pathname}?${params.toString()}`;

      navigate(newFullPath, { replace: true });
    },
    [location.pathname, location.search, navigate]
  );

  const handleIndividualSelect = useCallback(
    (value: string) => {
      let selectedItems = searchParams.get("selectedItems")?.split(",");
      if (!selectedItems || selectedItems === undefined) {
        searchParams.set("selectedItems", value);
        setSearchParms(searchParams);
        return;
      }
      let itemIndex = selectedItems?.findIndex((item) => item === value);
      if (itemIndex > -1) {
        selectedItems.splice(itemIndex, 1);
        const newSelectedItems = selectedItems
          ?.map((item) => item)
          .join(",")
          .toString();
        if (newSelectedItems.length) {
          searchParams.set("selectedItems", newSelectedItems);
        } else {
          searchParams.delete("selectedItems");
        }
        searchParams.set("selectAllItems", "0");
        setSearchParms(searchParams);
      } else {
        selectedItems?.push(value);
        const newSelectedItems = selectedItems
          ?.map((item) => item)
          .join(",")
          .toString();
        searchParams.set("selectedItems", newSelectedItems);
        setSearchParms(searchParams);
      }
    },
    [searchParams, setSearchParms]
  );

  const isSelected = useCallback(
    (value: string) => {
      const selectedItems = searchParams.get("selectedItems")?.split(",");
      if (!selectedItems) {
        return false;
      }
      return selectedItems.includes(value);
    },
    [searchParams]
  );

  const handleSelectAll = useCallback(
    (table: any) => {
      const {
        options: { data: tableData },
      } = table;
      const isSelected = searchParams.get("selectAllItems");
      if (isSelected === "1") {
        searchParams.set("selectAllItems", "0");
        searchParams.delete("selectedItems");
        setSearchParms(searchParams);
      } else {
        const selectedItems = tableData
          ?.map((item: any) => item.id)
          .join(",")
          .toString();
        searchParams.set("selectAllItems", "1");
        searchParams.set("selectedItems", selectedItems);
        setSearchParms(searchParams);
      }
    },
    [searchParams, setSearchParms]
  );

  const defaultColumns = useMemo(
    (): ColumnDef<any, any>[] => [
      {
        id: "select",
        header: ({ table }: any) => {
          return (
            <input
              type="checkbox"
              checked={checkedAllItems}
              onChange={() => handleSelectAll(table)}
              className={tw`cursor-pointer`}
            />
          );
        },
        cell: ({ row }: any) => (
          <input
            type="checkbox"
            checked={isSelected(row?.original?.id)}
            onChange={() => handleIndividualSelect(row?.original?.id)}
            className={tw`cursor-pointer`}
          />
        ),
      },
      {
        header: "WayBill",
        accessorKey: "tracking_number",
        cell: ({ row, getValue }: any) => {
          return (
            <button
              onClick={() => {
                appendSelectedItem(row?.original?.id);
              }}
              className={tw`cursor-pointer focus:outline-none px-4 relative`}
            >
              <ClientAccessControl
                children={
                  <p className={tw`whitespace-nowrap text-center`}>
                    {getValue() ?? "N/A"}
                  </p>
                }
                allowedPermissions={["can_view_tracking"]}
              />
              <ClientAccessControl allowedPermissions={["can_view_order_id"]}>
                <p
                  className={tw`text-xs text-gray-500 text-center whitespace-nowrap`}
                >
                  {row?.original?.order_number}
                </p>
              </ClientAccessControl>
              <ClientAccessControl
                children={
                  <p
                    className={tw`text-xs text-gray-500 uppercase text-center`}
                  >
                    {row?.original?.service_type?.name}
                  </p>
                }
                allowedPermissions={["can_view_service_type"]}
              />
              {row?.original?.is_on_hold && (
                <span
                  className={tw` absolute -top-2 text-[10px] -right-5 text-white px-[4px] bg-red-400 rounded-full `}
                >
                  H
                </span>
              )}
              {row?.original?.is_pickup_created && (
                <span
                  className={tw` absolute -top-2 text-[10px] -right-1 text-white px-[4px] bg-red-400 rounded-full `}
                >
                  P
                </span>
              )}
            </button>
          );
        },
      },
      {
        header: "Date",
        accessorKey: "created",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              {getValue() ? (
                <p className={tw`whitespace-nowrap`}>
                  {moment(getValue()).format("YY-MM-DD HH:mm:ss")}
                </p>
              ) : (
                "N/A"
              )}
            </>
          );
        },
      },
      {
        header: "Origin",
        accessorKey: "pickup_branch.name",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <p className={tw`uppercase`}>{getValue()}</p>
              <p className={tw`text-xs text-primary`}>
                {row?.original?.pickup_branch?.warehouse?.name}
              </p>
            </>
          );
        },
      },
      {
        header: "Sender",
        accessorKey: "sender.full_name",
        cell: ({ row }: any) => {
          return (
            <>
              <ClientAccessControl
                children={
                  <p className={tw``}>
                    {row?.original?.sender?.full_name ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_sender_name"]}
              />
              <ClientAccessControl
                children={
                  <p className={tw`whitespace-nowrap text-sm`}>
                    {row?.original?.sender?.primary_contact ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_sender_number"]}
              />
            </>
          );
        },
      },
      {
        header: "Receiver",
        accessorKey: "receiver.full_name",
        cell: ({ row }: any) => {
          return (
            <>
              <ClientAccessControl
                children={
                  <p className={tw``}>
                    {row?.original?.receiver.full_name ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_receiver_name"]}
              />
              <ClientAccessControl
                children={
                  <p className={tw`whitespace-nowrap text-sm`}>
                    {row?.original?.receiver.primary_contact ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_receiver_number"]}
              />
              <ClientAccessControl
                children={
                  <p className={tw`text-sm`}>
                    {row?.original?.receiver.address ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_receiver_location"]}
              />
            </>
          );
        },
      },
      {
        header: "Destination",
        accessorKey: "destination.name",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <p className={tw`uppercase`}>{getValue()}</p>
              <p className={tw`text-xs text-primary`}>
                {row?.original?.destination_branch?.warehouse?.name}
              </p>
            </>
          );
        },
      },

      {
        header: "Piece",
        accessorKey: "piece",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <ClientAccessControl allowedPermissions={["can_view_piece"]}>
                <button
                  className={tw`cursor-pointerb focus:outline-none`}
                  onClick={() => {
                    setOpensuborderPopup(!openSuborderpopup);
                    setRowid(row?.original?.id);
                  }}
                >
                  {getValue() ?? 0.0}
                </button>
              </ClientAccessControl>
            </>
          );
        },
      },
      {
        header: "Remarks",
        accessorKey: "remark",
        cell: ({ row, getValue }: any) => (
          <>
            <ClientAccessControl
              children={
                <button
                  className={tw`focus:outline-none`}
                  onClick={() => {
                    setSelectedOrder(row?.original?.id);
                    setOpenReviewModal(true);
                  }}
                >
                  {getValue()} Remarks
                </button>
              }
              allowedPermissions={["can_view_remarks"]}
              renderNoAccess={<p>{getValue()} Remarks</p>}
            />
          </>
        ),
      },
      {
        header: "Status",
        accessorKey: "delivery_status.name",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <ClientAccessControl
                children={
                  <>
                    <p
                      className={tw`uppercase px-1 text-center rounded-md`}
                      style={{
                        background: row?.original?.delivery_status?.color,
                      }}
                    >
                      {getValue()}
                    </p>
                    <p className={tw`text-xs text-primary `}>
                      {row?.original?.rider?.name}
                    </p>
                  </>
                }
                allowedPermissions={["can_view_status"]}
              />
            </>
          );
        },
      },
    ],
    [
      appendSelectedItem,
      handleIndividualSelect,
      checkedAllItems,
      handleSelectAll,
      isLoading,
      isSelected,
      openDeletePopup,
      openSuborderpopup,
      setOpenDeletePopup,
    ]
  );
  const handleactiveButton = (button) => {
    setISactive(button);
  };

  const handleHoldOrder = async (selectedOrder: any, setError: any) => {
    const url = `${APIS.ORDER}hold/`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false);
        queryClient.refetchQueries();
      }
    } catch (err) {
      toast.success("Somethings went wrong");
    }
  };

  const handleActionMenu = (
    data: any,
    status: any,
    type: string,
    setError: any
  ) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder) {
      toast.error("Please select one order first");
      setOrderActionMenu(false);
      return;
    }
    if (type === "Change Status") {
      setOpenDeliveryformPopup(true);
      setOrderActionMenu(false);
      setDeliveryStatus(status?.id);
    } else if (type === "Hold/Release") {
      handleHoldOrder(selectedOrder, setError);
    }
  };

  const filterParams = watch();

  useEffect(() => {
    if (selectedOrderDetails) {
      setOpenOrderHistoryPopup(true);
    } else {
      setOpenOrderHistoryPopup(false);
    }
  }, [selectedOrderDetails]);

  const handleClosePopup = () => {
    setOpenOrderHistoryPopup(false);
    setTimeout(() => {
      const params = new URLSearchParams(location.search);
      params.delete("selectedItem");
      const newFullPath = `${location.pathname}?${params.toString()}`;
      navigate(newFullPath, { replace: true });
    }, 300);
  };

  const handleDeleteModalClose = () => {
    setOpenDeletePopup(!openDeletePopup);
    clearErrors("comment");
    resetComment();
  };

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
      delivery_status__in: filterParams?.delivery_status__in
        ? filterParams.delivery_status__in.map((d) => ({
            id: d.value,
            name: d.label,
            label: d.label,
            value: d.value,
          }))
        : localState?.delivery_status__in,
    });
  }, [filterParams]);

  const operations = filterParams["operations"];

  const filters = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      <DataTable
        url={APIS.ORDER}
        queryKey={"orders"}
        columns={defaultColumns}
        tableName={"consignments-list"}
        isUpload={false}
        handleDetailNavigate={() => {
          console.log("detail navigate");
        }}
        params={{
          delivery_status__in: "918b8bf2-cc0a-4c43-be9c-c864f3416808",
          destination__in: cityIds,
        }}
      />
      <Modal
        isOpen={orderActionMenu}
        setIsOpen={setOrderActionMenu}
        title={actionType}
      >
        <OrderActionMenu
          handleActionMenu={handleActionMenu}
          setOrderActionMenu={setOrderActionMenu}
          actionType={actionType}
          isLoading={isPostLoading}
        />
      </Modal>
      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
      >
        <div className={tw`w-[600px]`}>
          <Remark selectedOrder={selectedOrder} />
        </div>
      </Modal>
      <Modal
        isOpen={openorderhistoryPopup}
        title={"Order Detail"}
        setIsOpen={handleClosePopup}
      >
        <OrderDetailPage selectedOrder={selectedOrderDetails} />
      </Modal>
      <Modal
        isOpen={openSuborderpopup}
        setIsOpen={setOpensuborderPopup}
        title={"Sub Orders"}
      >
        <div className={tw`w-[600px] `}>
          <Suborders id={rowid} />
        </div>
      </Modal>
    </>
  );
};

export default ConsignmentList;
